export enum ELimitValueType {
    Inferieur = 1,
    InferieurOuEgal = 2,
    Egal = 3,
    SuperieurOuEgal = 4,
    Superieur = 5,
}